import { render, staticRenderFns } from "./EstimatesOldPageCell.vue?vue&type=template&id=9cf05b50&"
import script from "./EstimatesOldPageCell.vue?vue&type=script&lang=js&"
export * from "./EstimatesOldPageCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports